<template>
  <div>
    <transition name="fade">
      <div v-if="policy">
        <p class="text-5xl font-bold text-red-500 p1">{{ $t("Policy") }}</p>
        <div>
          <v-icon name="download"></v-icon> Anti-CorruptionPolicy<a
            href="/Anti-CorruptionPolicy.pdf"
            download
          >
            Download</a
          >
        </div>
        <div>
          <v-icon name="download"></v-icon> FM_Certificate of Membership_WE ARE
          LOGISTICS (1998) COMPANY LIMITED<a
            href="/FM_Certificate.pdf"
            download
          >
            Download</a
          >
        </div>
        <div>
          <v-icon name="download"></v-icon> WCA China Global Membership
          Certificate<a href="/WCA-Membership.pdf" download> Download</a>
        </div>
        <div>
          <div class="flex justify-center flex-wrap mt-6">
            <img
              src="@/assets/images/elements/FM_Certificate.png"
              alt="airfreight-cover"
              class="object-contain overlay-card h-auto opacity-100 rounded-lg w-1/4 mr-3"
            />
            <img
              src="@/assets/images/elements/WCA-Membership.png"
              alt="airfreight-cover"
              class="object-contain overlay-card h-auto opacity-100 rounded-lg w-1/4"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      policy: false
    };
  },
  methods: {},
  created() {
    setTimeout(() => {
      this.policy = true;
    }, 5000);
  }
};
</script>

<style lang="stylus" scoped>
.p1 {
  color: red;
}

.p2 {
  color: black;
}

.icon {
  width: 24px;
}

.icon:hover {
  color: rgb(219, 53, 53);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 2s;
}
</style>
